import { FC, ReactNode } from "react";
import BookitupDocument from "../../types/BookitupDocument";
import { QRCodeSVG } from "qrcode.react";
import { Group, Space, Stack, Text } from "@mantine/core";
import { getDocumentTranslator } from "./documentLanguage";
import { useLingui } from "@lingui/react";

interface Props {
  invoice: BookitupDocument;
}

const InvoiceQrCodes: FC<Props> = ({ invoice }) => {
  const { epcQrPayment, paypalPaymentUrl } = invoice;
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, invoice.language);
  const atLeastOneQrCodePresent = epcQrPayment || paypalPaymentUrl;

  if (!atLeastOneQrCodePresent) return null;

  return (
    <>
      <Space h="xl" />
      <Group position="center">
        {epcQrPayment && (
          <QrCodeWithDescription
            title={t("transferQrTitle")}
            description={t("transferQrDescription")}
            qrCode={epcQrPayment}
          />
        )}
        {paypalPaymentUrl && (
          <QrCodeWithDescription
            title={t("paypalQrTitle")}
            description={
              <Text>
                {t("paypalQrDescriptionStart")}{" "}
                <a href={paypalPaymentUrl}>{t("paypalQrDescriptionLink")}</a>
                {t("paypalQrDescriptionEnd")}
              </Text>
            }
            qrCode={paypalPaymentUrl}
          />
        )}
      </Group>
    </>
  );
};

const QrCodeWithDescription: FC<{
  title: string;
  description: ReactNode;
  qrCode: string;
}> = ({ title, description, qrCode }) => {
  return (
    <Group
      p="xs"
      position="apart"
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: 4,
        width: 330,
      }}
    >
      <Stack spacing={0} sx={{ width: 200 }}>
        <Text mb="xs" size="xs" weight="bolder">
          {" "}
          {title}
        </Text>
        <Text size="xs">{description}</Text>
      </Stack>
      <div>
        <QRCodeSVG size={64} value={qrCode} />
      </div>
    </Group>
  );
};

export default InvoiceQrCodes;
